// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file ProcedureDTOList.proto (package ProcedureDTOList, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { ProcedureDTO } from "./ProcedureDTO_pb";
import { file_ProcedureDTO } from "./ProcedureDTO_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ProcedureDTOList.proto.
 */
export const file_ProcedureDTOList: GenFile = /*@__PURE__*/
  fileDesc("ChZQcm9jZWR1cmVEVE9MaXN0LnByb3RvEhBQcm9jZWR1cmVEVE9MaXN0IkAKEFByb2NlZHVyZURUT0xpc3QSLAoIZW50aXRpZXMYASADKAsyGi5Qcm9jZWR1cmVEVE8uUHJvY2VkdXJlRFRPQkYKLWNvbS5nbXYuZGVtZXRlci5uYXZhaWRzLm1vZGVsLnByb3RvLmdlbmVyYXRlZEIVUHJvY2VkdXJlRFRPTGlzdFByb3RvYgZwcm90bzM", [file_ProcedureDTO]);

/**
 * @generated from message ProcedureDTOList.ProcedureDTOList
 */
export type ProcedureDTOList = Message<"ProcedureDTOList.ProcedureDTOList"> & {
  /**
   * @generated from field: repeated ProcedureDTO.ProcedureDTO entities = 1;
   */
  entities: ProcedureDTO[];
};

/**
 * Describes the message ProcedureDTOList.ProcedureDTOList.
 * Use `create(ProcedureDTOListSchema)` to create a new message.
 */
export const ProcedureDTOListSchema: GenMessage<ProcedureDTOList> = /*@__PURE__*/
  messageDesc(file_ProcedureDTOList, 0);

